import {Material} from '../types'

export const mapToMaterialsById = (data: Material[]): Record<string, Material> =>
  data.reduce(
    (materialsById, material) => ({...materialsById, [String(material.id)]: material}),
    {} as Record<string, Material>
  )
